import { render, staticRenderFns } from "./TqEventStatusBar.vue?vue&type=template&id=358563d2&scoped=true&"
import script from "./TqEventStatusBar.vue?vue&type=script&lang=js&"
export * from "./TqEventStatusBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358563d2",
  null
  
)

export default component.exports